import { useOnline } from '../hooks/useOnline';

interface SignInProps {
  onSignIn: () => void;
}

export function SignIn({ onSignIn }: SignInProps) {
  const online = useOnline();

  return (
    <main className="signin">
      <h1>Sudoku</h1>
      {online ? (
        <>
          <p>A daily puzzle, streaks, and a global leaderboard. Sign in to play.</p>
          <button type="button" className="primary" onClick={onSignIn}>
            Sign in
          </button>
        </>
      ) : (
        <>
          <p>You’re offline. Reconnect to sign in — signing in needs a connection.</p>
          <button type="button" className="primary" disabled>
            Sign in
          </button>
        </>
      )}
    </main>
  );
}
